module.exports = __webpack_public_path__ + "img/mobilehardwareOpen3.279b2dc9.png";